import {
    Button,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useState } from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddBrand from "../../Modals/addbrand"; // can be renamed to AddAdBanner later

const AdBanner = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");


    // Example data (mock rows)
    const [rows, setRows] = useState([
        {
            id: 1,
            bannerImage: "/static/images/placeholder.png",
            title: "Summer Sale Bonanza",
            startDate: "01 July 2025",
            endDate: "31 July 2025",
            status: true,
        },
        {
            id: 2,
            bannerImage: "/static/images/placeholder.png",
            title: "Festival Offer",
            startDate: "01 Oct 2025",
            endDate: "20 Oct 2025",
            status: false,
        },
        {
            id: 3,
            bannerImage: "/static/images/placeholder.png",
            title: "New Arrivals Collection",
            startDate: "10 Sep 2025",
            endDate: "10 Dec 2025",
            status: true,
        },
    ]);



    return (
        <>
            <div className="main_title">
                <h1>Manage Ad Banners</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Ad Banners
                </p>
            </div>

            <div className="cards">
                {/* ---------- Header ---------- */}
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setSearchTerm}
                            placeholder="Search Ads..."
                        />
                    </div>
                    <div className="right_s">
                        <Button
                            className="btn btn_primary"
                            onClick={()=> navigate("add")}
                        >
                            <AddIcon /> Add Ad Banner
                        </Button>
                    </div>
                </div>

                {/* ---------- Table ---------- */}
                <TableContainer className="table_container">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sr. No.</TableCell>
                                <TableCell>Banner Image</TableCell>
                                <TableCell>Ad Title</TableCell>
                                <TableCell>Start Date</TableCell>
                                <TableCell>End Date</TableCell>
                                <TableCell>Make Introspection Banner</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {rows
                                .filter((row) =>
                                    row.title.toLowerCase().includes(searchTerm.toLowerCase())
                                )
                                .map((row, index) => (
                                    <TableRow hover key={row.id}>
                                        <TableCell>{index + 1}</TableCell>

                                        {/* Banner Image */}
                                        <TableCell>
                                            <Box className="user_block">
                                                <figure>
                                                    <img
                                                        src={row.bannerImage || "/static/images/placeholder.png"}
                                                        alt={row.title}

                                                    />
                                                </figure>
                                            </Box>
                                        </TableCell>

                                        {/* Ad Title */}
                                        <TableCell>
                                            <b>{row.title}</b>
                                        </TableCell>

                                        {/* Dates */}
                                        <TableCell>{row.startDate}</TableCell>
                                        <TableCell>{row.endDate}</TableCell>

                                        {/* Status Toggle */}
                                        <TableCell>
                                            <SwitchToggle />
                                        </TableCell>
                                        <TableCell>
                                            <SwitchToggle />
                                        </TableCell>

                                        {/* Actions */}
                                        <TableCell>
                                            <div className="table_actions v2">
                                                <Box>
                                                    <IconButton onClick={() => navigate("/ad-banner/view")}>
                                                        <img src="/static/images/eye_icon.svg" alt="View" />
                                                    </IconButton>
                                                </Box>
                                                <Box>
                                                    <IconButton onClick={() => navigate("/ad-banner/add")}>
                                                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                                                    </IconButton>
                                                </Box>
                                                <Box>
                                                    <IconButton>
                                                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                                                    </IconButton>
                                                </Box>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

        </>
    );
};

export default AdBanner;
